export const isChildElement = (element: HTMLElement, parent: HTMLElement): boolean=>{
    if (element && parent && element == parent){
        return true;
    } else if (element && element.parentElement){
        return isChildElement(element.parentElement, parent)
    } else {
        return false;
    }
}